export default __webpack_public_path__ + "static/media/header-hamburger.9258c810.svg";